<template>
  <div class="wl-brochure" v-if="template">
    <draggable v-model="template" handle=".group-handle" @end="update_order">
      <div
        class="wl-group"
        v-for="(group, index) in template"
        :key="index"
        @end="update_order"
      >
        <h5
          class="wl-group-header"
          :class="{ 'group-handle': editable }"
          v-if="group.name"
        >
          <svg
            class="bi"
            fill="currentColor"
            width="17px"
            height="17px"
            v-if="editable"
          >
            <use
              xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#arrows-move"
            />
          </svg>
          {{ group.name }}
        </h5>
        <draggable v-model="group.items" handle=".handle" @end="update_order">
          <search-result-trade
            winelist
            v-for="item in group.items"
            :key="item.product._id"
            :result="item.product"
            :wl-item="item"
            :editable="editable"
            @hide="hide_item(item.item_code, $event)"
            @remove-item="$emit('remove-item', { item_code: item.item_code })"
          ></search-result-trade>
        </draggable>
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import SearchResultTrade from "@/components/SearchResultTrade";

export default {
  components: {
    Draggable,
    SearchResultTrade,
  },
  props: {
    value: {
      type: Array,
    },
    slug: {
      type: String,
    },
    presentationMode: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.data_incoming = true;
    this.template = JSON.parse(JSON.stringify(this.value));
  },
  methods: {
    hide_item(item_code, hide) {
      this.$emit("hide-item", {
        template: "BROCHURE",
        data: {
          item_code,
          hide,
        },
      });
    },
    update_order() {
      this.$emit("update-order", {
        template: "BROCHURE",
        data: {
          groups: this.template,
        },
      });
    },
  },
  watch: {
    value: {
      deep: true,
      handler(val) {
        this.data_incoming = true;
        this.template = JSON.parse(JSON.stringify(val));
      },
    },
    template: {
      deep: true,
      handler(val) {
        if (this.data_incoming) {
          this.data_incoming = false;
          return;
        }

        this.$emit("change", val);
      },
    },
  },
  data() {
    return {
      template: false,
      data_incoming: false,
    };
  },
};
</script>
